import React from 'react';
import { Link } from 'react-router-dom';
import './ServiceTemplate.css';

function TrainTheTrainer() {
  return (
    <div className="service-page">
      <section className="service-hero" style={{backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(https://customer-assets.emergentagent.com/job_fitlaunch/artifacts/zz5fdv5i_20250723_133519.jpeg)`, backgroundPosition: 'center 30%'}}>
        <div className="container">
          <h1><span className="fit-inline"><span className="f-orange">F</span>-IT</span> Train the Trainer</h1>
          <p style={{color: '#FF6B35', fontSize: '1.1em', marginBottom: '10px', fontWeight: '500', fontStyle: 'italic'}}>Born from lived experience, built on psychology, driven by passion</p>
          <p className="subtitle">Build internal capacity to deliver F-IT workshops and create lasting cultural change</p>
        </div>
      </section>

      {/* White section with F-IT logo repeating pattern */}
      <div style={{
        width: '100%', 
        padding: '60px 20px', 
        position: 'relative',
        background: `
          linear-gradient(rgba(255, 255, 255, 0.95), rgba(255, 255, 255, 0.95)),
          url(/fit-logo.jpg)
        `,
        backgroundSize: 'auto, 100px 100px',
        backgroundRepeat: 'no-repeat, repeat',
        backgroundPosition: '0 0, 0 0'
      }}>
        <div style={{maxWidth: '1200px', margin: '0 auto', position: 'relative', zIndex: 1}}>
          <h2 style={{fontSize: '36px', color: '#2c3e50', marginBottom: '20px', fontFamily: 'Arial, sans-serif', fontWeight: 'bold'}}>Sustainable, Long-Term Capability</h2>
          <p>The F-IT Train the Trainer programme equips your internal champions to deliver F-IT workshops independently. Rather than relying on external consultants for every session, you build sustainable capability within your organisation.</p>
          <p>This approach allows you to embed F-IT into your culture at scale, reaching more people, more often, while maintaining the authenticity and impact that makes F-IT so powerful.</p>
          <p style={{marginBottom: 0}}><strong>The training isn't complicated</strong> - F-IT's power comes from personal, authentic delivery rather than rigid scripts. Participants are encouraged to add their own spin, expertise, and examples to make the workshop their own while maintaining the core elements that make F-IT effective.</p>
        </div>
      </div>

      {/* Grey section - Who Should Attend */}
      <div style={{backgroundColor: '#f9f9f9', width: '100%', padding: '80px 20px'}}>
        <div style={{maxWidth: '1200px', margin: '0 auto'}}>
          <h2 style={{fontSize: '36px', color: '#2c3e50', marginBottom: '20px', fontFamily: 'Arial, sans-serif', fontWeight: 'bold'}}>Who Should Attend?</h2>
          <p>This certification programme is designed for internal facilitators who will champion F-IT within your organisation:</p>
          <ul>
            <li><strong>HR Professionals</strong> - Leading wellbeing and employee engagement initiatives</li>
            <li><strong>Learning & Development Teams</strong> - Responsible for training and organisational development</li>
            <li><strong>Health & Safety Leaders</strong> - Connecting wellbeing to safety outcomes</li>
            <li><strong>Internal Facilitators</strong> - Experienced in delivering workshops and training</li>
            <li><strong>Wellbeing Champions</strong> - Passionate about mental health and workplace culture</li>
          </ul>
        </div>
      </div>

      {/* White section - Certification Program */}
      <div style={{width: '100%', padding: '80px 20px'}}>
        <div style={{maxWidth: '1200px', margin: '0 auto'}}>
          <h2 style={{fontSize: '36px', color: '#2c3e50', marginBottom: '20px', fontFamily: 'Arial, sans-serif', fontWeight: 'bold'}}>Comprehensive Certification Programme</h2>
          <div style={{textAlign: 'center', margin: '30px 0'}}>
            <img src="https://customer-assets.emergentagent.com/job_mindset-tools-web/artifacts/u3jm1ub1_Fit%20TtT%201.jpeg" alt="F-IT Workshop Certification" style={{maxWidth: '400px', height: 'auto', boxShadow: '0 4px 10px rgba(0,0,0,0.2)', borderRadius: '8px'}} />
          </div>
          <p>Our Train the Trainer programme ensures you have everything needed to deliver impactful F-IT workshops with confidence and authenticity.</p>
        </div>
      </div>

      {/* Grey section - What's Included */}
      <div style={{backgroundColor: '#f2f2f2', width: '100%', padding: '80px 20px'}}>
        <div style={{maxWidth: '1200px', margin: '0 auto'}}>
          <h2 style={{fontSize: '36px', color: '#2c3e50', marginBottom: '20px', fontFamily: 'Arial, sans-serif', fontWeight: 'bold'}}>What's Included</h2>
          <ul>
            <li>Full certification as a F-IT Workshop facilitator</li>
            <li>Deep understanding of the F-IT methodology and psychology</li>
            <li>All workshop materials, slides, and facilitation guides</li>
            <li>Access to Jason's story and presentation materials</li>
            <li>Guidance on facilitating the Traffic Light Exercise</li>
            <li>The Communication Exercise toolkit and facilitation notes</li>
            <li>How to deliver the "Speak Up / Are You OK / What's Your F-IT Score" exercise</li>
            <li>Sean Toon's 'Reaching the Brink' presentation materials (with permission)</li>
            <li>Facilitation techniques for creating psychological safety</li>
            <li>License to deliver F-IT workshops internally within your organisation</li>
            <li>Ongoing support and access to updated materials</li>
            <li>Connection to the F-IT facilitator community</li>
          </ul>
        </div>
      </div>

      {/* White section - Program Structure */}
      <div style={{width: '100%', padding: '80px 20px'}}>
        <div style={{maxWidth: '1200px', margin: '0 auto'}}>
          <h2 style={{fontSize: '36px', color: '#2c3e50', marginBottom: '20px', fontFamily: 'Arial, sans-serif', fontWeight: 'bold'}}>Programme Structure</h2>
          <p>We offer two flexible options depending on whether your facilitators have already experienced the F-IT workshop:</p>
          
          <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '20px', marginTop: '30px'}}>
            <div style={{backgroundColor: '#FFF5F0', padding: '30px', borderRadius: '8px', borderTop: '4px solid #FF6B35'}}>
              <h3 style={{fontSize: '24px', color: '#FF6B35', marginBottom: '15px'}}>Option 1: Full Day Training (6 Hours)</h3>
              <p><strong>Part 1: Immersion</strong> - Jason delivers the complete F-IT workshop so facilitators experience it as participants</p>
              <p><strong>Part 2: Facilitation Training</strong> - Learn how to deliver the workshop, understand the core elements, and discover how to make it your own</p>
              <p style={{margin: 0, fontStyle: 'italic'}}><em>Perfect for facilitators who haven't experienced a F-IT workshop yet</em></p>
            </div>
            <div style={{backgroundColor: '#FFF5F0', padding: '30px', borderRadius: '8px', borderTop: '4px solid #FF6B35'}}>
              <h3 style={{fontSize: '24px', color: '#FF6B35', marginBottom: '15px'}}>Option 2: Training Only (4 Hours)</h3>
              <p><strong>Facilitation Training</strong> - Focused training on delivering the workshop for those who have already experienced it as participants</p>
              <p>Learn the core elements that must be covered, explore facilitation techniques, and understand how to personalise the delivery with your own expertise and examples</p>
              <p style={{margin: 0, fontStyle: 'italic'}}><em>For facilitators who have already attended a F-IT workshop</em></p>
            </div>
          </div>
          
          <p style={{marginTop: '30px', backgroundColor: '#f9f9f9', padding: '20px', borderRadius: '8px'}}><strong>Part 3: Practice & Feedback</strong> - After the training day, facilitators practice delivery in their own time, building confidence before delivering their first live workshop. We're available for support and feedback as you prepare.</p>
        </div>
      </div>

      {/* Grey section - Make It Your Own */}
      <div style={{backgroundColor: '#ebebeb', width: '100%', padding: '80px 20px'}}>
        <div style={{maxWidth: '1200px', margin: '0 auto'}}>
          <h2 style={{fontSize: '36px', color: '#2c3e50', marginBottom: '20px', fontFamily: 'Arial, sans-serif', fontWeight: 'bold'}}>Make It Your Own</h2>
          <p>This isn't a rigid script to memorise. While there are core elements that must be explained to maintain F-IT's effectiveness, the real power comes from your personal delivery of the workshop.</p>
          <p>You're encouraged to:</p>
          <ul>
            <li>Add your own expertise and professional insights</li>
            <li>Use examples relevant to your organisation and industry</li>
            <li>Bring your own style and personality to the facilitation</li>
            <li>Adapt discussions to address your company's specific challenges</li>
            <li>Make the content resonate with your unique workplace culture</li>
          </ul>
          <p>Authenticity is what makes F-IT work - and that includes your authentic voice as a facilitator.</p>
        </div>
      </div>

      {/* White section - Why Train Internal Facilitators */}
      <div style={{width: '100%', padding: '80px 20px'}}>
        <div style={{maxWidth: '1200px', margin: '0 auto'}}>
          <h2 style={{fontSize: '36px', color: '#2c3e50', marginBottom: '20px', fontFamily: 'Arial, sans-serif', fontWeight: 'bold'}}>Why Train Internal Facilitators?</h2>
          
          <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '20px', marginTop: '30px'}}>
            <div style={{backgroundColor: '#f9f9f9', padding: '30px', borderRadius: '8px', textAlign: 'center', boxShadow: '0 2px 10px rgba(0,0,0,0.1)'}}>
              <h3 style={{fontSize: '24px', color: '#FF6B35', marginBottom: '15px'}}>Scale Rapidly</h3>
              <p style={{margin: 0}}>Reach more employees across multiple sites and departments without logistical constraints</p>
            </div>
            <div style={{backgroundColor: '#f9f9f9', padding: '30px', borderRadius: '8px', textAlign: 'center', boxShadow: '0 2px 10px rgba(0,0,0,0.1)'}}>
              <h3 style={{fontSize: '24px', color: '#FF6B35', marginBottom: '15px'}}>Cultural Ownership</h3>
              <p style={{margin: 0}}>F-IT becomes part of your organisation's identity, not an external programme</p>
            </div>
            <div style={{backgroundColor: '#f9f9f9', padding: '30px', borderRadius: '8px', textAlign: 'center', boxShadow: '0 2px 10px rgba(0,0,0,0.1)'}}>
              <h3 style={{fontSize: '24px', color: '#FF6B35', marginBottom: '15px'}}>Cost Effective</h3>
              <p style={{margin: 0}}>Deliver unlimited workshops after initial certification investment</p>
            </div>
            <div style={{backgroundColor: '#f9f9f9', padding: '30px', borderRadius: '8px', textAlign: 'center', boxShadow: '0 2px 10px rgba(0,0,0,0.1)'}}>
              <h3 style={{fontSize: '24px', color: '#FF6B35', marginBottom: '15px'}}>Contextual Relevance</h3>
              <p style={{margin: 0}}>Internal facilitators can tailor examples and discussions to your specific workplace</p>
            </div>
          </div>
        </div>
      </div>

      {/* Grey section - Ongoing Support */}
      <div style={{backgroundColor: '#f2f2f2', width: '100%', padding: '80px 20px'}}>
        <div style={{maxWidth: '1200px', margin: '0 auto'}}>
          <h2 style={{fontSize: '36px', color: '#2c3e50', marginBottom: '20px', fontFamily: 'Arial, sans-serif', fontWeight: 'bold'}}>Ongoing Support</h2>
          <p>Certification is just the beginning. We provide ongoing support to ensure your internal facilitators continue to deliver impactful workshops:</p>
          <ul>
            <li>Access to updated materials and new resources</li>
            <li>Connection to the F-IT facilitator community for peer support</li>
            <li>Annual refresher sessions and advanced facilitation techniques</li>
            <li>Support with complex situations or challenging workshops</li>
            <li>Updates on latest research and F-IT methodology developments</li>
          </ul>
        </div>
      </div>

      {/* White section - Maintaining Authenticity */}
      <div style={{width: '100%', padding: '80px 20px'}}>
        <div style={{maxWidth: '1200px', margin: '0 auto'}}>
          <h2 style={{fontSize: '36px', color: '#2c3e50', marginBottom: '20px', fontFamily: 'Arial, sans-serif', fontWeight: 'bold'}}>Maintaining Authenticity</h2>
          <p>One of the keys to F-IT's power is its authenticity. Our Train the Trainer programme ensures that internal facilitators maintain this authenticity while making the content relevant to your organisation.</p>
          <p>You'll learn how to tell Jason's story with respect and impact, facilitate difficult conversations with compassion, and create the psychological safety needed for honest discussions about wellbeing.</p>
        </div>
      </div>

      {/* Grey section - Training in Action */}
      <div style={{backgroundColor: '#f9f9f9', width: '100%', padding: '80px 20px'}}>
        <div style={{maxWidth: '1200px', margin: '0 auto'}}>
          <h2 style={{fontSize: '36px', color: '#2c3e50', marginBottom: '20px', fontFamily: 'Arial, sans-serif', fontWeight: 'bold'}}>Training in Action</h2>
          <div style={{display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '20px'}}>
            <div style={{height: '350px', overflow: 'hidden', borderRadius: '8px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)'}}>
              <img src="https://customer-assets.emergentagent.com/job_premium-fit-site/artifacts/ofzemfka_1000003098.jpeg" alt="Facilitator training session" style={{width: '100%', height: '100%', objectFit: 'cover'}} />
            </div>
            <div style={{height: '350px', overflow: 'hidden', borderRadius: '8px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)'}}>
              <img src="https://customer-assets.emergentagent.com/job_mindset-tools-web/artifacts/ks8gp90u_fit%20ttt%202.jpeg" alt="Train the Trainer workshop delivery" style={{width: '100%', height: '100%', objectFit: 'cover'}} />
            </div>
          </div>
        </div>
      </div>

      {/* White section - Testimonials */}
      <div style={{width: '100%', padding: '80px 20px'}}>
        <div style={{maxWidth: '1200px', margin: '0 auto'}}>
          <h2 style={{fontSize: '36px', color: '#2c3e50', marginBottom: '30px', fontFamily: 'Arial, sans-serif', fontWeight: 'bold'}}>What Organisations Say</h2>
          
          <div style={{backgroundColor: '#FFF5F0', padding: '30px', borderRadius: '8px', borderLeft: '5px solid #FF6B35', boxShadow: '0 2px 10px rgba(0,0,0,0.05)'}}>
            <p style={{fontSize: '16px', fontStyle: 'italic', marginBottom: '15px', lineHeight: '1.7'}}>"Due to the transient nature of workers we have on our ever-evolving construction projects, the F-IT Train the Trainer programme has been invaluable. It allows us to deliver the training ourselves as new teams join, and crucially, we can implement specific wording and examples that are directly relevant to our projects and the challenges our people face on site. Having internal facilitators means we can reach everyone, no matter how our workforce changes."</p>
            <p style={{fontWeight: 'bold', color: '#FF6B35', margin: 0}}>— Construction Project Manager</p>
          </div>
        </div>
      </div>

      {/* Pricing section */}
      <div style={{backgroundColor: '#f9f9f9', width: '100%', padding: '80px 20px'}}>
        <div style={{maxWidth: '800px', margin: '0 auto', backgroundColor: '#fff', padding: '40px', borderRadius: '8px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)'}}>
          <h3 style={{fontSize: '28px', color: '#2c3e50', marginBottom: '20px', fontFamily: 'Arial, sans-serif', fontWeight: 'bold'}}>Investment</h3>
          <p><strong>Option 1 - Full Day:</strong> 6 hours (Workshop + Training) - From £5,000</p>
          <p><strong>Option 2 - Training Only:</strong> 4 hours (for those who've attended a workshop) - From £2,995</p>
          <p><strong>Group Size:</strong> Up to 20 facilitators per cohort</p>
          <p style={{marginBottom: 0}}><em>Includes all materials, ongoing support, and license to deliver F-IT workshops internally</em></p>
        </div>
      </div>

      <section className="cta-section">
        <div className="container">
          <h2>Ready to Build Internal F-IT Capability?</h2>
          <p>Create lasting change by empowering your team to deliver F-IT&nbsp;workshops</p>
          <div style={{display: 'flex', gap: '30px', justifyContent: 'center', flexWrap: 'wrap', marginTop: '30px'}}>
            <div style={{backgroundColor: 'rgba(255,255,255,0.1)', padding: '25px', borderRadius: '8px', textAlign: 'center', minWidth: '250px'}}>
              <h3 style={{color: '#FF6B35', marginBottom: '10px'}}>Book a Consultation</h3>
              <p style={{fontSize: '14px', marginBottom: '15px'}}>Discuss certification for your internal facilitators</p>
              <Link to="/contact" className="cta-btn cta-btn-primary">Get In Touch</Link>
            </div>
            <div style={{backgroundColor: 'rgba(255,255,255,0.1)', padding: '25px', borderRadius: '8px', textAlign: 'center', minWidth: '250px'}}>
              <h3 style={{color: '#FF6B35', marginBottom: '10px'}}>Explore Services</h3>
              <p style={{fontSize: '14px', marginBottom: '15px'}}>See our full range of workshops and training</p>
              <Link to="/how-it-works" className="cta-btn cta-btn-secondary">View All Services</Link>
            </div>
          </div>
          <div style={{marginTop: '30px', fontSize: '15px'}}>
            <p style={{margin: '5px 0'}}>01636 550190 option 5 <span style={{fontSize: '13px', opacity: '0.8'}}>(Mon-Fri 9am-5pm)</span></p>
            <p style={{margin: '5px 0'}}>hello@f-itscore.com</p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default TrainTheTrainer;
